export const calculateBboxStyle = (bbox, imgElement) => {
  if (!bbox || !imgElement) return {};

  const intrinsicWidth = imgElement.naturalWidth;
  const intrinsicHeight = imgElement.naturalHeight;
  const renderedWidth = imgElement.clientWidth;
  const renderedHeight = imgElement.clientHeight;

  const imgAspectRatio = intrinsicWidth / intrinsicHeight;
  const containerAspectRatio = renderedWidth / renderedHeight;

  let scale;
  let offsetX = 0;
  let offsetY = 0;

  if (imgAspectRatio > containerAspectRatio) {
    scale = renderedWidth / intrinsicWidth;
    offsetY = (renderedHeight - intrinsicHeight * scale) / 2;
  } else {
    scale = renderedHeight / intrinsicHeight;
    offsetX = (renderedWidth - intrinsicWidth * scale) / 2;
  }

  return {
    left: `${bbox[0] * scale + offsetX}px`,
    top: `${bbox[1] * scale + offsetY}px`,
    width: `${(bbox[2] - bbox[0]) * scale}px`,
    height: `${(bbox[3] - bbox[1]) * scale}px`,
  };
};
